export class SurveyQuestionFinalizeModel {
    constructor(
        public assessmentId: string,
        public respondentType: number,
    ) {
        this.assessmentId = assessmentId;
        this.respondentType = respondentType;
    }
}